<template>
  <div class="item-card">
    <template v-if="loading">
      <div class="card-image-wrapper" style="background: #f3f4f6; border-radius: 5px;"></div>
      <a-skeleton active :title="false" :paragraph="{ rows: 5 }" />
    </template>
    <template v-else>
      <div class="card-header">
      <div class="likes">
        <svg class="heart-icon tag-icon" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.41l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.41zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
        </svg>
        <span>{{ item.lf_id }}</span>
      </div>
    </div>

    <div class="card-image-wrapper">
      <img v-if="displayImage" :src="displayImage" :alt="item.item_name || 'Lost item'" class="card-image"
        @error="handleImageError" />
      <div v-else class="fallback-image">
        <svg class="temp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z">
          </path>
        </svg>
      </div>
    </div>

    <div class="card-content">
      <h3 class="item-title">{{ item.item_name }}</h3>
      <div class="item-type-tag">{{ item.item_type }}</div>
      <p class="item-detail">{{ item.item_detail }}</p>

      <div class="item-location-info">
        <div class="info-block">
          <div class="info-header">
            <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
            </svg>
            <span class="info-label">Found at</span>
          </div>
          <div class="info-value">{{ item.item_find }}</div>
        </div>
        <div class="info-block">
          <div class="info-header">
            <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
              </path>
            </svg>
            <span class="info-label">Pick up at</span>
          </div>
          <div class="info-value">{{ item.item_position }}</div>
        </div>
      </div>
    </div>

    <!--  
      <div class="card-actions">
        <button class="btn-primary">View Details</button>
      </div>
    -->
    </template>
  </div>
</template>

<script>
const TEMP_LOST_IMAGES = {
  'Wallets': '/images/tempLost/wallets.png',
  'National ID Cards and other cards': '/images/tempLost/national_id_cards.png',
  'Mobile Phone': '/images/tempLost/mobile_phone.png',
  'บัตรประจำตัวนักศึกษา (Student IDs)': '/images/tempLost/student_ids.png',
  'Cash': '/images/tempLost/cash.png',
  'Credit / Debit Cards': '/images/tempLost/credit_debit_cards.png'
};

export default {
  name: 'ItemCard',
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imageError: false
    }
  },
  computed: {
    tempImage() {
      return this.getTempImage(this.item ? this.item.item_type : '');
    },
    displayImage() {
      if (this.imageError) {
        return null;
      }
      if (this.tempImage) {
        return this.tempImage;
      }
      if (this.item && this.item.image) {
        return this.item.image;
      }
      return null;
    }
  },
  watch: {
    'item.image'() {
      this.imageError = false;
    },
    'item.item_type'() {
      this.imageError = false;
    }
  },
  methods: {
    handleImageError() {
      this.imageError = true;
    },
    getTempImage(type) {
      if (!type || typeof type !== 'string') return null;
      const trimmed = type.trim();

      // Direct exact match
      if (TEMP_LOST_IMAGES[trimmed]) {
        return TEMP_LOST_IMAGES[trimmed];
      }

      const lower = trimmed.toLowerCase();

      // Student IDs (check before general ID cards)
      if (
        lower.includes('student id') ||
        lower.includes('student card') ||
        trimmed.includes('บัตรประจำตัวนักศึกษา') ||
        trimmed.includes('บัตรนักศึกษา')
      ) {
        return TEMP_LOST_IMAGES['บัตรประจำตัวนักศึกษา (Student IDs)'];
      }

      // National ID Cards and other cards
      if (
        lower.includes('national id') ||
        lower.includes('other card') ||
        lower.includes('id card') ||
        lower.includes('identity card') ||
        trimmed.includes('บัตรประชาชน') ||
        trimmed.includes('บัตรประจำตัวประชาชน')
      ) {
        return TEMP_LOST_IMAGES['National ID Cards and other cards'];
      }

      // Wallets
      if (
        lower.includes('wallet') ||
        trimmed.includes('กระเป๋าเงิน') ||
        trimmed.includes('กระเป๋าสตางค์')
      ) {
        return TEMP_LOST_IMAGES['Wallets'];
      }

      // Mobile Phone
      if (
        lower.includes('phone') ||
        lower.includes('mobile') ||
        trimmed.includes('โทรศัพท์') ||
        trimmed.includes('มือถือ')
      ) {
        return TEMP_LOST_IMAGES['Mobile Phone'];
      }

      // Cash
      if (
        lower.includes('cash') ||
        lower.includes('money') ||
        trimmed.includes('เงินสด')
      ) {
        return TEMP_LOST_IMAGES['Cash'];
      }

      // Credit / Debit Cards
      if (
        lower.includes('credit') ||
        lower.includes('debit') ||
        trimmed.includes('บัตรเครดิต') ||
        trimmed.includes('บัตรเดบิต')
      ) {
        return TEMP_LOST_IMAGES['Credit / Debit Cards'];
      }

      return null;
    }
  }
}
</script>

<style scoped>
.item-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
}

.item-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.likes {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #502b80;
  font-weight: 600;
  font-size: 0.9rem;
}

.heart-icon {
  width: 18px;
  height: 18px;
  color: #502b80;
}

.status-badge {
  background: #f97316;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status-badge.lost {
  background: #ef4444;
}

.status-badge.found {
  background: #22c55e;
}

.card-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  width: 100%;
  height: 200px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #f3f4f6;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
  display: block;
}

.fallback-image {
  width: 100%;
  height: 100%;
  background-color: #f3f4f6;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.temp-icon {
  width: 64px;
  height: 64px;
  color: #9ca3af;
}

.card-content {
  text-align: left;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}

.item-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
}

.item-type-tag {
  display: inline-block;
  background: #f3e8ff;
  color: #502b80;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  align-self: flex-start;
}

.item-detail {
  color: #6b7280;
  font-size: 0.85rem;
  margin: 0 0 1rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item-location-info {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
}

.info-block:last-child {
  margin-bottom: 0;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.2rem;
}

.info-icon {
  width: 14px;
  height: 14px;
  color: #9ca3af;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
  padding-left: 1.2rem;
}

.card-actions {
  display: flex;
  justify-content: center;
}

.btn-primary {
  width: 100%;
  background: #502b80;
  color: white;
  border: none;
  padding: 0.6rem 0;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-primary:hover {
  background: #3e2163;
}
</style>
